// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-components-templates-people-js" + "-" + "ea44d3e376c9e3073757" + ".js";
};